
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import BookingCalendar from './BookingCalendar';

interface BookingDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mentorId: string;
  applicationId: string;
  mentorName: string;
  courseTitle: string;
}

const BookingDialog = ({ 
  open, 
  onOpenChange, 
  mentorId, 
  applicationId, 
  mentorName, 
  courseTitle 
}: BookingDialogProps) => {
  const handleBookingComplete = () => {
    console.log('DEBUG: BookingDialog - Booking completed for applicationId:', applicationId);
    onOpenChange(false);
    
    // Instead of window.location.reload(), dispatch a general booking update event
    // The subscription-specific event is already dispatched from BookingCalendar
    const event = new CustomEvent('booking-completed', {
      detail: {
        applicationId,
        mentorId,
        timestamp: new Date().toISOString()
      }
    });
    window.dispatchEvent(event);
    
    console.log('DEBUG: BookingDialog - Dispatched booking-completed event');
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>
            Book Session with {mentorName}
          </DialogTitle>
          <p className="text-gray-600">{courseTitle}</p>
        </DialogHeader>
        
        <BookingCalendar 
          mentorId={mentorId}
          applicationId={applicationId}
          onBookingComplete={handleBookingComplete}
        />
      </DialogContent>
    </Dialog>
  );
};

export default BookingDialog;
